module.exports = __webpack_public_path__ + "static/media/clinician-watchman-device-2388w.229f7373.jpg";